export default function (props) {
  return <div className='flex pl-2 py-4 items-center justify-center'>
    <div className='text-base text-white font-bold'>{props.title}</div>
  </div>
}
